import { render, staticRenderFns } from "./apartments-overview-notice.vue?vue&type=template&id=23b14b4e&scoped=true&"
import script from "./apartments-overview-notice.ts?vue&type=script&lang=ts&"
export * from "./apartments-overview-notice.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-overview-notice.scss?vue&type=style&index=0&id=23b14b4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b14b4e",
  null
  
)

export default component.exports